module.exports = __webpack_public_path__ + "media/images/bg_accent-6ecdc1ae609b904fd10a2f1f7f721337.png";